import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import env from "react-dotenv";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { installOrderAccessInterceptors } from "./orderAccess";

Bugsnag.start({
  apiKey: "d80bec9c094bbe977203eb727291ea9b",
  plugins: [new BugsnagPluginReact()],
});

installOrderAccessInterceptors();

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

ReactDOM.render(
  <ErrorBoundary>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("portal")
);
